<template>
  <div id="bar4">
    <li v-for="(item, index) in items" :key="index">
      <h2>{{ item.number }}</h2>
      <img src="static/kanbanbg.png" alt="" />
      <p>{{ item.name }}</p>
    </li>
  </div>
</template>
<script>
import lytable from "../lytable.vue";
export default {
  components: { lytable },
  data() {
    return {
      items: [{
        name: '待调度',
        number: 0
      },{
        name: '已调度',
        number: 0
      },{
        name: '进行中',
        number: 0
      }],
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 12,
        sort: 2,
        startTime: "",
      },

      //http://120.25.144.155:8001/gps-d?carld=3630#/login
      //http://120.25.144.155:8001/gps-d?carld=3630
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      this.getData();
    },

    getData() {
      return;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/data/sumAlarmAsc",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        //console.log(data);
        /* ar obj = {};
        for (let i = 0; i < data.length; i++) {
          var key = data[i].type;
          if (!obj[key]) {
            obj[key] = [];
          }
          obj[key].push(data[i]);
        } */
        var t = [
          {
            name: "接打电话",
            number: 0,
          },
          {
            name: "抽烟驾驶",
            number: 0,
          },
          {
            name: "疲劳驾驶",
            number: 0,
          },
        ];
        t[0].number = data.telAlarm;
        t[1].number = data.smokeAlarm;
        t[2].number = data.tiredAlarm;
        /* for (let i = 0; i < data.length; i++) {
          if (data[i].type.indexOf("电话") != -1) {
            t[0].number += Number(data[i].number);
          } else if (data[i].type.indexOf("抽烟") != -1) {
            t[1].number += Number(data[i].number);
          } else {
            t[2].number += Number(data[i].number);
          }
        } */
        this.items = t;
      });
    },
  },
};
</script>
<style>
#bar4 {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 20px;
}

#bar4 li img {
  width: 100%;
  opacity: 0.7;
}

#bar4 li h2 {
  font-size: 40px;
  font-weight: bold;
  color: #00fcfa;
}

#bar4 li p {
  color: #00fcfa;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/diaodu/paigongxiangmu.vue